'use client';

import { type ReactNode, useEffect, useState, useRef } from 'react';
import { usePageLogger } from '../hooks/usePageLogger';
import { type LogParameters } from '../models';
interface Props {
  params?: LogParameters;
  children: ReactNode;
}
export const LoggingView = ({
  params,
  children
}: Props) => {
  const logger = usePageLogger();
  const [hasLogged, setHasLogged] = useState(false);
  const prevParamsRef = useRef<LogParameters | undefined>(params);
  useEffect(() => {
    if (logger?.isInitialized === false) {
      return;
    }
    if (!hasLogged) {
      logger?.view(params);
      setHasLogged(true);
      prevParamsRef.current = params;
      return;
    }
    const paramsChanged = prevParamsRef.current !== params;
    if (paramsChanged) {
      logger?.view(params);
      prevParamsRef.current = params;
    }
  }, [logger, params, hasLogged]);
  return <>{children}</>;
};